import { createAction, createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const mobilePatrolsRequest = createRequest(constants.mobilePatrols);
export const mobilePatrolsSuccess = createSuccess(constants.mobilePatrols);
export const mobilePatrolsFailure = createFailure(constants.mobilePatrols);

export const mobilePatrolInfoRequest = createRequest(`${constants.mobilePatrols}_GET_PATROL`);
export const mobilePatrolInfoSuccess = createSuccess(`${constants.mobilePatrols}_GET_PATROL`);
export const mobilePatrolInfoFailure = createFailure(`${constants.mobilePatrols}_GET_PATROL`);

export const updateMobilePatrolsStatusRequest = createRequest(`${constants.mobilePatrols}_UPDATE_STATUS`);
export const updateMobilePatrolsStatusSuccess = createSuccess(`${constants.mobilePatrols}_UPDATE_STATUS`);
export const updateMobilePatrolsStatusFailure = createFailure(`${constants.mobilePatrols}_UPDATE_STATUS`);

export const createMobilePatrolsRequest = createRequest(`${constants.mobilePatrols}_CREATE`);
export const createMobilePatrolsSuccess = createSuccess(`${constants.mobilePatrols}_CREATE`);
export const createMobilePatrolsFailure = createFailure(`${constants.mobilePatrols}_CREATE`);

export const updateMobilePatrolsRequest = createRequest(`${constants.mobilePatrols}_UPDATE`);
export const updateMobilePatrolsSuccess = createSuccess(`${constants.mobilePatrols}_UPDATE`);
export const updateMobilePatrolsFailure = createFailure(`${constants.mobilePatrols}_UPDATE`);

export const deleteMobileUnitRequest = createRequest(`${constants.mobilePatrols}_DELETE`);
export const deleteMobileUnitSuccess = createSuccess(`${constants.mobilePatrols}_DELETE`);
export const deleteMobileUnitFailure = createFailure(`${constants.mobilePatrols}_DELETE`);

export const mobilePatrolTagsRequest = createRequest(`${constants.mobilePatrols}_TAGS`);
export const mobilePatrolTagsSuccess = createSuccess(`${constants.mobilePatrols}_TAGS`);
export const mobilePatrolTagsFailure = createFailure(`${constants.mobilePatrols}_TAGS`);

export const updateMobilePatrolTagRequest = createRequest(`${constants.mobilePatrols}_UPDATE_TAG`);
export const updateMobilePatrolTagSuccess = createSuccess(`${constants.mobilePatrols}_UPDATE_TAG`);
export const updateMobilePatrolTagFailure = createFailure(`${constants.mobilePatrols}_UPDATE_TAG`);

export const disableMobilePatrolTagRequest = createRequest(`${constants.mobilePatrols}_DISABLE_TAG`);
export const disableMobilePatrolTagSuccess = createSuccess(`${constants.mobilePatrols}_DISABLE_TAG`);
export const disableMobilePatrolTagFailure = createFailure(`${constants.mobilePatrols}_DISABLE_TAG`);

export const enableMobilePatrolTagRequest = createRequest(`${constants.mobilePatrols}_ENABLE_TAG`);
export const enableMobilePatrolTagSuccess = createSuccess(`${constants.mobilePatrols}_ENABLE_TAG`);
export const enableMobilePatrolTagFailure = createFailure(`${constants.mobilePatrols}_ENABLE_TAG`);

export const deleteMobilePatrolTagRequest = createRequest(`${constants.mobilePatrols}_DELETE_TAG`);
export const deleteMobilePatrolTagSuccess = createSuccess(`${constants.mobilePatrols}_DELETE_TAG`);
export const deleteMobilePatrolTagFailure = createFailure(`${constants.mobilePatrols}_DELETE_TAG`);

export const deselectMobilePatrols = createAction(`${constants.mobilePatrols}_DESELECT`);

export const requestMobilePatrols = mobilePatrolsRequest;
export const requestMobilePatrolInfo = mobilePatrolInfoRequest;
export const updateMobilePatrolsStatus = updateMobilePatrolsStatusRequest;
export const createMobilePatrols = createMobilePatrolsRequest;
export const updateMobilePatrols = updateMobilePatrolsRequest;
export const deleteMobileUnit = deleteMobileUnitRequest;
export const requestMobilePatrolTags = mobilePatrolTagsRequest;
export const updateMobilePatrolTag = updateMobilePatrolTagRequest;
export const disableMobilePatrolTag = disableMobilePatrolTagRequest;
export const enableMobilePatrolTag = enableMobilePatrolTagRequest;
export const deleteMobilePatrolTag = deleteMobilePatrolTagRequest;
